[
  {
    "paletteName": "Lets Hear It For The Boys",
    "paletteTags": [
      "Super Load Movers"
    ],
    "color_1": "#000000",
    "color_2": "#FFFFFF",
    "color_11": "#F0F0F0",
    "color_12": "#C0C0C0",
    "color_13": "#909090",
    "color_14": "#606060",
    "color_15": "#303030",
    "color_16": "#B2BDE6",
    "color_17": "#8896CD",
    "color_18": "#3A54B4",
    "color_19": "#273878",
    "color_20": "#131C3C",
    "color_21": "#FFF2D4",
    "color_22": "#FEE6AA",
    "color_23": "#BFAD7F",
    "color_24": "#7F7355",
    "color_25": "#40392A",
    "color_26": "#FFC5BD",
    "color_27": "#FF8B7B",
    "color_28": "#BF685C",
    "color_29": "#80463E",
    "color_30": "#40231F",
    "color_31": "#A8D5DE",
    "color_32": "#78B2BE",
    "color_33": "#2A8A9D",
    "color_34": "#1C5C69",
    "color_35": "#0E2E34"
  },
  {
    "paletteName": "I See Red",
    "paletteTags": [
      "Electronic Shop"
    ],
    "color_1": "#FFFFFF",
    "color_2": "#000000",
    "color_11": "#FFFFFF",
    "color_12": "#D4D4D4",
    "color_13": "#909090",
    "color_14": "#606060",
    "color_15": "#303030",
    "color_16": "#D0DACC",
    "color_17": "#A9B6A4",
    "color_18": "#7D9174",
    "color_19": "#53614D",
    "color_20": "#2A3027",
    "color_21": "#DCD4C8",
    "color_22": "#B9AB98",
    "color_23": "#8B8072",
    "color_24": "#5D564C",
    "color_25": "#2E2B26",
    "color_26": "#DBCECF",
    "color_27": "#B7A7A7",
    "color_28": "#93797A",
    "color_29": "#625151",
    "color_30": "#312829",
    "color_31": "#C4D0D5",
    "color_32": "#99A6AB",
    "color_33": "#6D7B81",
    "color_34": "#3C4F57",
    "color_35": "#1E282C"
  },
  {
    "paletteName": "Im a Bumble Bee",
    "paletteTags": [
      "the bakery"
    ],
    "color_1": "#FFFFFF",
    "color_2": "#000000",
    "color_11": "#FFFFFF",
    "color_12": "#D4D4D4",
    "color_13": "#909090",
    "color_14": "#606060",
    "color_15": "#000000",
    "color_16": "#A0C2E8",
    "color_17": "#709DD1",
    "color_18": "#0D5EBA",
    "color_19": "#093F7C",
    "color_20": "#041F3E",
    "color_21": "#F6CCB0",
    "color_22": "#EEB188",
    "color_23": "#E57022",
    "color_24": "#994B17",
    "color_25": "#4C250B",
    "color_26": "#F1EEA7",
    "color_27": "#E4DE7B",
    "color_28": "#D6CC11",
    "color_29": "#8F880B",
    "color_30": "#474406",
    "color_31": "#B2E0BB",
    "color_32": "#86C091",
    "color_33": "#3FA152",
    "color_34": "#2A6B37",
    "color_35": "#15361B"
  },
  {
    "paletteName": "Licorice Allsorts In Blue",
    "paletteTags": [
      "Real Estate"
    ],
    "color_1": "#FFFFFF",
    "color_2": "#000000",
    "color_11": "#231111",
    "color_12": "#452222",
    "color_13": "#745656",
    "color_14": "#B89C9C",
    "color_15": "#E8DFDF",
    "color_16": "#321F1F",
    "color_17": "#653F3F",
    "color_18": "#C97D7D",
    "color_19": "#E0A2A2",
    "color_20": "#E4B9B9",
    "color_21": "#081F4E",
    "color_22": "#0F3E9B",
    "color_23": "#637EB4",
    "color_24": "#8FA4CD",
    "color_25": "#B2C3E6",
    "color_26": "#1F373B",
    "color_27": "#3F6F75",
    "color_28": "#5EA6B0",
    "color_29": "#9BC5CA",
    "color_30": "#C1E0E5",
    "color_31": "#353223",
    "color_32": "#6A6447",
    "color_33": "#9E966A",
    "color_34": "#D3C88D",
    "color_35": "#E9E3C2"
  },
  {
    "paletteName": "Pretty in Pink",
    "paletteTags": [
      "wedding 01"
    ],
    "color_1": "#000000",
    "color_2": "#FEFDFD",
    "color_11": "#F0FAFF",
    "color_12": "#CADDE6",
    "color_13": "#9AAEB8",
    "color_14": "#515E65",
    "color_15": "#292F33",
    "color_16": "#A4F7D5",
    "color_17": "#77EEBE",
    "color_18": "#00E689",
    "color_19": "#00995B",
    "color_20": "#004D2E",
    "color_21": "#C7FCF2",
    "color_22": "#91F9E6",
    "color_23": "#6DBBAD",
    "color_24": "#497D73",
    "color_25": "#243E3A",
    "color_26": "#C2E3D8",
    "color_27": "#9CC6B9",
    "color_28": "#61AA93",
    "color_29": "#417162",
    "color_30": "#203931",
    "color_31": "#B6CDE1",
    "color_32": "#91ABC2",
    "color_33": "#6587A4",
    "color_34": "#205685",
    "color_35": "#102B43"
  },
  {
    "paletteName": "Tranquil Sea",
    "paletteTags": [
      "spa reesort"
    ],
    "color_1": "#FFFFFF",
    "color_2": "#000000",
    "color_11": "#F3F2DC",
    "color_12": "#C2C2B0",
    "color_13": "#929184",
    "color_14": "#616158",
    "color_15": "#31302C",
    "color_16": "#C0CBDE",
    "color_17": "#96A4BE",
    "color_18": "#5C739D",
    "color_19": "#3D4D69",
    "color_20": "#1F2634",
    "color_21": "#F0E7CB",
    "color_22": "#E0D19C",
    "color_23": "#A89D75",
    "color_24": "#70694E",
    "color_25": "#383427",
    "color_26": "#FCDDB5",
    "color_27": "#F8CA90",
    "color_28": "#F59A28",
    "color_29": "#A3671B",
    "color_30": "#52330D",
    "color_31": "#BAD4D4",
    "color_32": "#8EA9AA",
    "color_33": "#607F80",
    "color_34": "#2B5455",
    "color_35": "#162A2A"
  },
  {
    "paletteName": "My Blue Sneakers",
    "paletteTags": [
      "amazing smile"
    ],
    "color_1": "#FFFFFF",
    "color_2": "#000000",
    "color_11": "#0E1821",
    "color_12": "#1C3142",
    "color_13": "#516371",
    "color_14": "#8293A1",
    "color_15": "#C5D0D9",
    "color_16": "#1E2A4B",
    "color_17": "#3D5495",
    "color_18": "#5B7EE0",
    "color_19": "#A5B7EA",
    "color_20": "#C4D1F5",
    "color_21": "#053342",
    "color_22": "#2B8FB3",
    "color_23": "#50C4ED",
    "color_24": "#86D2ED",
    "color_25": "#ABE0F2",
    "color_26": "#1D2932",
    "color_27": "#395264",
    "color_28": "#567B96",
    "color_29": "#92A8B9",
    "color_30": "#BDCFDC",
    "color_31": "#3F3C1F",
    "color_32": "#7D793E",
    "color_33": "#BCB55D",
    "color_34": "#FAF17C",
    "color_35": "#FCF8BD"
  },
  {
    "paletteName": "Chefs Like Orange",
    "paletteTags": [
      "Papas"
    ],
    "color_1": "#FDFDFE",
    "color_2": "#000000",
    "color_11": "#F2F2F2",
    "color_12": "#B6B6B6",
    "color_13": "#898989",
    "color_14": "#5B5B5B",
    "color_15": "#2E2E2E",
    "color_16": "#FFE5D9",
    "color_17": "#FFC1A3",
    "color_18": "#FFAA81",
    "color_19": "#7E5541",
    "color_20": "#3F2B21",
    "color_21": "#FFEFE8",
    "color_22": "#F9DED3",
    "color_23": "#DEC3B8",
    "color_24": "#645954",
    "color_25": "#322C2A",
    "color_26": "#CCDBD9",
    "color_27": "#A4B6B4",
    "color_28": "#75928E",
    "color_29": "#4E615F",
    "color_30": "#27312F",
    "color_31": "#BFC8D7",
    "color_32": "#959EAE",
    "color_33": "#697386",
    "color_34": "#35435D",
    "color_35": "#1B222F"
  },
  {
    "paletteName": "Corporate Blues",
    "paletteTags": [
      "James Consulting"
    ],
    "color_1": "#FFFFFF",
    "color_2": "#000000",
    "color_11": "#222120",
    "color_12": "#43423F",
    "color_13": "#72716F",
    "color_14": "#A1A09E",
    "color_15": "#D0CFCD",
    "color_16": "#2F261E",
    "color_17": "#5E4D3D",
    "color_18": "#BC9979",
    "color_19": "#D4B9A1",
    "color_20": "#E3D5C8",
    "color_21": "#252D28",
    "color_22": "#4B5A51",
    "color_23": "#708779",
    "color_24": "#A0AFA6",
    "color_25": "#CBD7D0",
    "color_26": "#4F3316",
    "color_27": "#9E662C",
    "color_28": "#ED9942",
    "color_29": "#F3C89B",
    "color_30": "#F9DCBD",
    "color_31": "#282829",
    "color_32": "#505052",
    "color_33": "#78797C",
    "color_34": "#A0A1A5",
    "color_35": "#CFCFD2"
  },
  {
    "paletteName": "At The Car Wash Yeah",
    "paletteTags": [
      "moving company"
    ],
    "color_1": "#FFFFFF",
    "color_2": "#000000",
    "color_11": "#FFFFFF",
    "color_12": "#CCCCCC",
    "color_13": "#808080",
    "color_14": "#555555",
    "color_15": "#2A2A2A",
    "color_16": "#FFEEBC",
    "color_17": "#FFDE7A",
    "color_18": "#FFC824",
    "color_19": "#AA8924",
    "color_20": "#554412",
    "color_21": "#FFE0E3",
    "color_22": "#FFC5C9",
    "color_23": "#E68E94",
    "color_24": "#A85258",
    "color_25": "#6B1E23",
    "color_26": "#FED1BF",
    "color_27": "#FEBA9E",
    "color_28": "#FD763F",
    "color_29": "#A94F2A",
    "color_30": "#542715",
    "color_31": "#DFA3A6",
    "color_32": "#C07275",
    "color_33": "#A01F24",
    "color_34": "#6B1518",
    "color_35": "#350A0C"
  },
  {
    "paletteName": "Sleeping Beauty Wakes",
    "paletteTags": [
      "interiors and co"
    ],
    "color_1": "#000000",
    "color_2": "#FFFFFF",
    "color_11": "#1C191C",
    "color_12": "#494549",
    "color_13": "#777377",
    "color_14": "#A4A0A4",
    "color_15": "#D2CDD2",
    "color_16": "#552018",
    "color_17": "#A94130",
    "color_18": "#FE6148",
    "color_19": "#FEB0A3",
    "color_20": "#FFCAC2",
    "color_21": "#141E3F",
    "color_22": "#273C7D",
    "color_23": "#67759E",
    "color_24": "#929DBE",
    "color_25": "#B8C2DF",
    "color_26": "#1F3624",
    "color_27": "#3D6C47",
    "color_28": "#5CA26B",
    "color_29": "#97C1A0",
    "color_30": "#C0E0C7",
    "color_31": "#243236",
    "color_32": "#48656D",
    "color_33": "#6B97A3",
    "color_34": "#8FC9D9",
    "color_35": "#C4E3EC"
  },
  {
    "paletteName": "Elephant Walks",
    "paletteTags": [
      "Coach"
    ],
    "color_1": "#FFFFFF",
    "color_2": "#000000",
    "color_11": "#FFFFFF",
    "color_12": "#DBDBDB",
    "color_13": "#B3B3B3",
    "color_14": "#7A7A7A",
    "color_15": "#333333",
    "color_16": "#EDBFAF",
    "color_17": "#EB9C81",
    "color_18": "#E3815F",
    "color_19": "#755144",
    "color_20": "#332926",
    "color_21": "#C5F0E7",
    "color_22": "#96DBCD",
    "color_23": "#71D4C0",
    "color_24": "#52706A",
    "color_25": "#293835",
    "color_26": "#DEE8B7",
    "color_27": "#D0E094",
    "color_28": "#BBD16D",
    "color_29": "#707857",
    "color_30": "#2F312B",
    "color_31": "#D5D9ED",
    "color_32": "#AFB6E0",
    "color_33": "#919AC7",
    "color_34": "#6E77A8",
    "color_35": "#252838"
  },
  {
    "paletteName": "Skin Tone Portrait",
    "paletteTags": [
      "interior design"
    ],
    "color_1": "#000000",
    "color_2": "#FFFFFF",
    "color_11": "#323232",
    "color_12": "#5B5B5B",
    "color_13": "#848484",
    "color_14": "#ADADAD",
    "color_15": "#FFFFFF",
    "color_16": "#3A3321",
    "color_17": "#746743",
    "color_18": "#AE9A64",
    "color_19": "#C9BD9E",
    "color_20": "#E4DBC4",
    "color_21": "#282634",
    "color_22": "#504B67",
    "color_23": "#7D7A8D",
    "color_24": "#A6A3B3",
    "color_25": "#CDCAD9",
    "color_26": "#36241C",
    "color_27": "#6D4737",
    "color_28": "#A36B53",
    "color_29": "#C2A092",
    "color_30": "#E0C7BC",
    "color_31": "#282828",
    "color_32": "#515151",
    "color_33": "#797979",
    "color_34": "#A1A1A1",
    "color_35": "#D0D0D0"
  },
  {
    "paletteName": "Feelings Are Overrated",
    "paletteTags": [
      "The Soccer club"
    ],
    "color_1": "#FFFFFF",
    "color_2": "#000000",
    "color_11": "#EFEFEF",
    "color_12": "#BFBFBF",
    "color_13": "#8F8F8F",
    "color_14": "#606060",
    "color_15": "#303030",
    "color_16": "#ADC5D8",
    "color_17": "#839CB1",
    "color_18": "#54728A",
    "color_19": "#154063",
    "color_20": "#0A2032",
    "color_21": "#FCDACB",
    "color_22": "#FAB598",
    "color_23": "#BC8872",
    "color_24": "#7D5B4C",
    "color_25": "#3F2D26",
    "color_26": "#C1E5C5",
    "color_27": "#9BCCA1",
    "color_28": "#5DB267",
    "color_29": "#3E7745",
    "color_30": "#1F3B22",
    "color_31": "#C3CBDA",
    "color_32": "#9CA5B5",
    "color_33": "#727C90",
    "color_34": "#3E4E6B",
    "color_35": "#1F2736"
  },
  {
    "paletteName": "Lolas Nature Trip",
    "paletteTags": [
      "Lifestyle Mentor"
    ],
    "color_1": "#FFFFFF",
    "color_2": "#000000",
    "color_11": "#FFFFFF",
    "color_12": "#DBDBDB",
    "color_13": "#8F8F8F",
    "color_14": "#606060",
    "color_15": "#303030",
    "color_16": "#CCD2DB",
    "color_17": "#A4ABB6",
    "color_18": "#748092",
    "color_19": "#4D5561",
    "color_20": "#272B31",
    "color_21": "#F1FFEB",
    "color_22": "#DAF9CC",
    "color_23": "#A3B59A",
    "color_24": "#576452",
    "color_25": "#2C3229",
    "color_26": "#F2F2D0",
    "color_27": "#E3E3A6",
    "color_28": "#CFCF84",
    "color_29": "#686842",
    "color_30": "#343421",
    "color_31": "#CED6D5",
    "color_32": "#A3ACAB",
    "color_33": "#758381",
    "color_34": "#4E5756",
    "color_35": "#272C2B"
  },
  {
    "paletteName": "Black & White",
    "paletteTags": [
      "Photography Studio"
    ],
    "color_1": "#FFFFFF",
    "color_2": "#000000",
    "color_11": "#FFFFFF",
    "color_12": "#DBDBDB",
    "color_13": "#8F8F8F",
    "color_14": "#606060",
    "color_15": "#303030",
    "color_16": "#F5B8BC",
    "color_17": "#EB9499",
    "color_18": "#E13A44",
    "color_19": "#96272D",
    "color_20": "#4B1317",
    "color_21": "#C1F3ED",
    "color_22": "#88E6DC",
    "color_23": "#28D9C7",
    "color_24": "#44736E",
    "color_25": "#0F4842",
    "color_26": "#AFD7FA",
    "color_27": "#86C1F5",
    "color_28": "#178AF0",
    "color_29": "#0F5CA0",
    "color_30": "#082E50",
    "color_31": "#D7D4D1",
    "color_32": "#AFACA9",
    "color_33": "#878380",
    "color_34": "#5F5A55",
    "color_35": "#302D2B"
  },
  {
    "paletteName": "Minimalist White",
    "paletteTags": [
      "Dawkins&Dodger"
    ],
    "color_1": "#FFFFFF",
    "color_2": "#000000",
    "color_11": "#EDEBF2",
    "color_12": "#BEBCC2",
    "color_13": "#8E8D91",
    "color_14": "#5F5E61",
    "color_15": "#2F2F30",
    "color_16": "#C7CDD0",
    "color_17": "#979EA0",
    "color_18": "#676E71",
    "color_19": "#363E41",
    "color_20": "#1B1F21",
    "color_21": "#C6DFDC",
    "color_22": "#9EB2B0",
    "color_23": "#778684",
    "color_24": "#4F5958",
    "color_25": "#282D2C",
    "color_26": "#F0DFD8",
    "color_27": "#EBC9BC",
    "color_28": "#DBAB97",
    "color_29": "#A67560",
    "color_30": "#5C4339",
    "color_31": "#D7D3D2",
    "color_32": "#AEAAA9",
    "color_33": "#858180",
    "color_34": "#5D5755",
    "color_35": "#2F2C2B"
  },
  {
    "paletteName": "Hot Pink Bites",
    "paletteTags": [
      "Fashion Photographer"
    ],
    "color_1": "#FFFFFF",
    "color_2": "#000000",
    "color_11": "#FFFFFF",
    "color_12": "#BEBCC2",
    "color_13": "#8E8D91",
    "color_14": "#5F5E61",
    "color_15": "#2F2F30",
    "color_16": "#FFEEBC",
    "color_17": "#FFDC73",
    "color_18": "#F2BD1E",
    "color_19": "#AA8925",
    "color_20": "#554412",
    "color_21": "#E8E6C4",
    "color_22": "#D2CE90",
    "color_23": "#BBB546",
    "color_24": "#7D792F",
    "color_25": "#3E3C17",
    "color_26": "#BEDED7",
    "color_27": "#94BCB4",
    "color_28": "#599B8D",
    "color_29": "#3B675E",
    "color_30": "#1E342F",
    "color_31": "#C7CFD3",
    "color_32": "#9AA3A8",
    "color_33": "#6D777C",
    "color_34": "#3D4A50",
    "color_35": "#1F2528"
  },
  {
    "paletteName": "Business Edition",
    "paletteTags": [
      "success consulting"
    ],
    "color_1": "#FFFFFF",
    "color_2": "#000000",
    "color_11": "#2F2E2E",
    "color_12": "#595858",
    "color_13": "#828181",
    "color_14": "#ACABAB",
    "color_15": "#F2F2F2",
    "color_16": "#4D1916",
    "color_17": "#9B312D",
    "color_18": "#E84A43",
    "color_19": "#F09E9A",
    "color_20": "#F7BFBD",
    "color_21": "#141A2D",
    "color_22": "#293559",
    "color_23": "#5F6883",
    "color_24": "#8D95AC",
    "color_25": "#B9C0D5",
    "color_26": "#4F4B13",
    "color_27": "#9E9625",
    "color_28": "#EDE138",
    "color_29": "#F3ED96",
    "color_30": "#F9F5BA",
    "color_31": "#283E23",
    "color_32": "#517C45",
    "color_33": "#78BA68",
    "color_34": "#ACD1A3",
    "color_35": "#D3E8CE"
  },
  {
    "paletteName": "White on Black",
    "paletteTags": [
      "Jack Banks Photography"
    ],
    "color_1": "#FFFFFF",
    "color_2": "#000000",
    "color_11": "#FFFFFF",
    "color_12": "#BEBCC2",
    "color_13": "#8E8D91",
    "color_14": "#5F5E61",
    "color_15": "#2F2F30",
    "color_16": "#B2DED6",
    "color_17": "#85BDB3",
    "color_18": "#409C8C",
    "color_19": "#2B685D",
    "color_20": "#15342F",
    "color_21": "#FFDBC6",
    "color_22": "#FEB88D",
    "color_23": "#BF8A6A",
    "color_24": "#7F5C47",
    "color_25": "#402E23",
    "color_26": "#C0EEF5",
    "color_27": "#9FE1EA",
    "color_28": "#50CFE0",
    "color_29": "#358A95",
    "color_30": "#1B454B",
    "color_31": "#BFC8D7",
    "color_32": "#959EAE",
    "color_33": "#697386",
    "color_34": "#35435D",
    "color_35": "#1B222F"
  }
]
